let _ = require('lodash');

let productTeasers = document.querySelectorAll('.layout-product-teaser');

if (!_.isEmpty(productTeasers)) {
    let i = 1;

    Array.from(productTeasers).forEach(product => {
        product.setAttribute('data-position', i);

        product.addEventListener('click', (e) => {
            let productTitle = product.getAttribute('data-product-title');
            let productId = product.getAttribute('data-product-id');
            let productBrand = product.getAttribute('data-product-brand');
            let productPosition = product.getAttribute('data-position');

            let bodyClasses = document.body.classList;
            let list = '';

            if (bodyClasses.contains('page-node-type-product')) {
                list = 'Product Detail Page';
            } else if(bodyClasses.contains('page-node-type-brand') || bodyClasses.contains('page-node-type-sub-brand')){
                list = 'Product Overview Page';
            }

            pushToDataLayer(productTitle, productId, productBrand, list, productPosition);
        }); i++;
    });
}

function pushToDataLayer(name, id, brand, list, position) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
            'click': {
                'actionField': {'list': list},
                'products': [{
                    'name': name?.toLowerCase(),
                    'id': id,
                    'brand': brand,
                    'position': position
                }]
            }
        }
    });
}